import { Pipe } from '@angular/core';
import { isNumberFinite } from '../utils/utils';
var SqrtPipe = (function () {
    function SqrtPipe() {
    }
    SqrtPipe.prototype.transform = function (input) {
        if (!isNumberFinite(input)) {
            return 'NaN';
        }
        return Math.sqrt(input);
    };
    return SqrtPipe;
}());
export { SqrtPipe };
SqrtPipe.decorators = [
    { type: Pipe, args: [{
                name: 'sqrt'
            },] },
];
/** @nocollapse */
SqrtPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=sqrt.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/math/sqrt.pipe.js
// module id = 268
// module chunks = 103